import { parseDirectionOverrides, resolveDirectionOverrides } from '@/_pure/directionRule';
import { parsePrimitiveCameraCatalog, PRIMITIVE_CAMERA_CATALOG } from '@/adapters/primitive/_pure/derivation/primitiveCameraRules';
import { parsePrimitiveDirectionCatalog, PRIMITIVE_DIRECTION_CATALOG } from '@/adapters/primitive/_pure/derivation/primitiveDirectionRules';
import type { PrimitiveSceneDirection, PrimitiveSceneDirectionCatalogs } from '@/adapters/primitive/_contract/sceneDirection';

export function parsePrimitiveSceneDirection(value: unknown): PrimitiveSceneDirection | undefined {
    if (value === undefined) return undefined;
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid Primitive scene direction.');
    const object = value as Record<string, unknown>;
    for (const key of Object.keys(object)) if (key !== 'visuals' && key !== 'camera') throw new Error(`Unknown Primitive direction domain '${key}'.`);
    return {
        ...(object.visuals === undefined ? {} : { visuals: parseDirectionOverrides(object.visuals, PRIMITIVE_DIRECTION_CATALOG, parsePrimitiveDirectionCatalog) }),
        ...(object.camera === undefined ? {} : { camera: parseDirectionOverrides(object.camera, PRIMITIVE_CAMERA_CATALOG, parsePrimitiveCameraCatalog) }),
    };
}

export function resolvePrimitiveSceneDirection(direction?: PrimitiveSceneDirection): PrimitiveSceneDirectionCatalogs {
    return {
        visuals: resolveDirectionOverrides(PRIMITIVE_DIRECTION_CATALOG, direction?.visuals),
        camera: resolveDirectionOverrides(PRIMITIVE_CAMERA_CATALOG, direction?.camera),
    };
}
